export default __webpack_public_path__ + "static/media/be-bn.99b17797.png";